import { render, staticRenderFns } from "./PendingUsers.vue?vue&type=template&id=0b9b7d4c&scoped=true"
import script from "./PendingUsers.vue?vue&type=script&lang=js"
export * from "./PendingUsers.vue?vue&type=script&lang=js"
import style0 from "./PendingUsers.vue?vue&type=style&index=0&id=0b9b7d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b7d4c",
  null
  
)

export default component.exports